<template>
    <div class="basic-info-entry">
        <BasicTitle title="基本信息录入"></BasicTitle>
        <!--       内容     -->
        <div class="info-content">
            <div class="basic-items" v-for="item in arrBasicInfoEntry" :key="item.key">
                <div class="item-name"><span>{{ item.name }}</span><span class="required-point" v-if="item.require">*</span></div>
                <!--          选择值          -->
                <div v-if="item.switchBtn" class="item-values">
                    <input v-model="child.value" @focus="onInputFocus(child)" class="value-items" v-if="item.switchBtn" :class="{'select-value-items': item.selectValueKeys.includes(child.key)}" v-for="child in item.values" :key="child.key">
                </div>
                <div v-else class="item-values">
                    <div class="value-items" :class="{'select-value-items': item.selectValueKeys.includes(child.key)}" @click="selectBasicValue(item.key,child.key)" v-for="child in item.values" :key="child.key">{{ child.value }}</div>
                </div>

            </div>
        </div>

        <!--    签单手选择   -->
        <VantPopup v-model="userSelectVisible" class="select-user-container">
            <div class="title-content">
                <div>选择勘察人员</div>
                <div class="button" @click="changSysUser">确定</div>
            </div>
            <div class="input-container">
                <input v-model="searchUser" placeholder="搜索姓名" type="text">
                <p @click="getSysUser(searchUser)"> 搜索</p>
            </div>

            <div class="list-container">
                <p v-for="i in sysUserList" @click="selectSysUser(i)" :key="i.systemuserid">{{ i.fullname }} <img v-if="i.select" :src="require('@/assets/images/hvac/mapping/finish-icon.png')" alt=""></p>
            </div>
        </VantPopup>
    </div>
</template>

<script>
import BasicTitle from './basictitle';
import {mapState} from "vuex";
import {Popup,} from 'vant'

export default {
    name: "basicInfo",
    computed: {
        ...mapState({
            // 上门勘察基本信息
            arrBasicInfoEntry: state => state.hvacMappingEntry.arrBasicInfoEntry,
            // 用户信息（签单手）
            objSignHandInfo: state => state.hvacMappingEntry.objSignHandInfo,
            // 报告信息
            objReportInfo: state => state.hvacMappingEntry.objReportInfo,
        })
    },
    data() {
        return {
            // 签单手选择显示
            userSelectVisible: false,
            // 签单手列表
            sysUserList: [],
            // 搜索
            searchUser: ''
        }
    },
    components: {
        BasicTitle,
        VantPopup: Popup
    },
    watch: {
        objSignHandInfo: {
            handler(v) {
                const {fullname} = v;
                this.fullSignHandInfo(fullname);
            },
            immediate: true,
        }
    },
    methods: {

        /**
         * 改变签单手用户
         */
        changSysUser() {
            const info = this.sysUserList.find(i => i.select);
            if (info) {
                this.$store.commit({type: 'hvacMappingEntry/SAVE_SIGN_HAND_INFO', info});
                this.showUserSelect();
            }
        },
        /**
         * 选择用户
         * @param item
         */
        selectSysUser(item) {
            this.sysUserList = this.sysUserList.map(i => {
                i.select = i.systemuserid === item.systemuserid;
                return i;
            })
        },

        /**
         * 获取签单手列表
         * @param search 搜索关键字
         */
        async getSysUser(search) {
            this.sysUserList = await this.$store.dispatch({type: 'hvacMappingEntry/getSysUserList', search});
        },

        /**
         * 基本信息选择点击
         * @param itemKey 元素标识
         * @param childKey 子集标识
         */
        selectBasicValue(itemKey, childKey) {
            const list = this.arrBasicInfoEntry.map(item => {
                if (item.key === itemKey) {
                    if (item.multi) {
                        // 多选
                        if (item.selectValueKeys.includes(childKey)) {
                            item.selectValueKeys = item.selectValueKeys.filter(i => i !== childKey)
                        } else {
                            item.selectValueKeys.push(childKey);
                        }
                    } else {
                        // 单选
                        item.selectValueKeys = [childKey];
                    }
                }
                return item;
            });

            // 是否需要更新远程数据
            const hasConfig = this.objReportInfo.config_ids?.length;
            hasConfig && this.$store.dispatch({type: 'hvacMappingEntry/setReportConfigInfo'});

            this.$store.commit({type: 'hvacMappingEntry/CHANGE_BASIC_INFO_ENTRY', list})
        },
        /**
         * 填充签单手信息
         */
        fullSignHandInfo(name) {
            const list = this.arrBasicInfoEntry.map(item => {
                if (item.switchBtn) {
                    // 单选
                    item.selectValueKeys = [item.values[0].key];
                    // 填充信息
                    item.values[0].value = name ?? item.values[0].value;
                }
                return item;
            });
            this.$store.commit({type: 'hvacMappingEntry/CHANGE_BASIC_INFO_ENTRY', list})
        },
        /**
         * 输入聚焦触发显示
         * @param child
         */
        async onInputFocus(child) {
            if (child.key === '1') {
                await this.getSysUser();
                this.showUserSelect();
            }
        },
        /**
         * 签单用户选择显示控制
         */
        showUserSelect() {
            this.userSelectVisible = !this.userSelectVisible;
        }
    }
}
</script>

<style scoped lang="scss">


.basic-info-entry {
    padding: 32px 24px 28px;
    border-radius: $commonRadius;
    background: #FFFFFF;
    margin-bottom: 28px;

    .info-content {
        padding-top: 30px;

        .basic-items {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 24px;


            .item-name {
                flex: 0 0 170px;
                display: flex;
                align-items: flex-end;
                line-height: 40px;
                height: 40px;

                .required-point {
                    line-height: 30px;
                    color: $warnText
                }
            }

            .item-values {
                flex: 1 1 auto;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .value-items {
                    line-height: 80px;
                    text-align: center;
                    border-radius: $commonRadius;
                    background: #F7F7F7;
                    flex: 1;
                    margin-right: 20px;
                    color: #A2A2A2;
                    transition: all 0.5s;

                    &:last-child {
                        margin-right: 0;
                    }
                }

                .select-value-items {
                    background: rgba($deepGreen, 0.1);
                    color: $deepGreen;
                }
            }

            &:last-child {
                margin-bottom: 0;
                flex-wrap: wrap;

                .item-name {
                    flex: 0 0 100%;
                    margin-bottom: 16px;
                }

                .item-values {
                    .value-items {
                        margin-right: 18px;

                        &:last-child {
                            margin-right: 0;
                        }
                    }
                }
            }
        }
    }

    .select-user-container {
        width: 80vw;
        height: 80vh;
        border-radius: 12px;
        padding: 40px 24px 24px;

        .title-content {
            font-size: $bigSize;
            padding: 0 0 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .button {
                width: 120px;
                border-radius: 12px;
                height: 50px;
                background: $deepGreen;
                color: white;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 28px;
            }
        }


        .input-container {
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: #F7F7F7;
            width: 100%;
            padding: 0 20px;

            input {
                background: transparent;
                color: $deepGreen;
                line-height: 80px;
                border-radius: $commonRadius;
            }
        }


        .list-container {
            max-height: 64vh;
            overflow-y: auto;

            p {
                padding: 16px 0;
                border-bottom: 1px solid #F7F7F7;
                display: flex;
                justify-content: space-between;
                align-items: center;

                img {
                    width: 40px;
                    height: 40px;
                }
            }

        }

    }
}


</style>